import { createFileRoute } from "@tanstack/react-router";
import { LegalDocumentPage } from "@/components/LegalDocumentPage";

export const Route = createFileRoute("/privacy")({
  component: () => <LegalDocumentPage slug="privacy" fallbackTitle="Privacy Policy" />,
  head: () => ({
    meta: [
      { title: "Privacy Policy - Inquira" },
      { name: "description", content: "How Inquira collects, uses, and protects your data." },
      { property: "og:title", content: "Privacy Policy - Inquira" },
      { property: "og:description", content: "How Inquira collects, uses, and protects your data." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});